// extracted by mini-css-extract-plugin
export default {"card":"Card_card__95JUx","head":"Card_head__n3bZI","title":"Card_title__a2QZe"};